import React from "react";
import { useNavigate } from "react-router-dom";

const NaytaKoriinNappi = (props) => {
  const { asetatila, tuoteId } = props;
  const navigate = useNavigate();

  function handleClick(event) {
    event.preventDefault();
    const tid = event.target.name;
    asetatila("kori", { tid, muutos: 1 });
    navigate("/kori");
    // if (tila.kori.get("lkm") === 1) {
    //   document.documentElement.style.setProperty(
    //     "--koriAnimaatio",
    //     "koriAnimaatio"
    //   );
    // }
  }
  return (
    <button
      className="nappi2"
      // type="button"
      name={tuoteId}
      onClick={handleClick}
      title="Lisää tuote ostoskoriin"
    >
      Koriin
    </button>
  );
};
export default NaytaKoriinNappi;
